module.exports = __webpack_public_path__ + "img/product-three-1.be13990b.png";